// Indian number formatters
export const CR = 10000000;
export const L = 100000;

export const fmtINR = (n, opts = {}) => {
    if (n == null || isNaN(n)) return "—";
    const abs = Math.abs(n);
    let val, unit;
    if (abs >= CR) { val = n / CR; unit = "Cr"; }
    else if (abs >= L) { val = n / L; unit = "L"; }
    else { val = n; unit = ""; }
    const dp = opts.dp ?? (abs >= CR ? 2 : abs >= L ? 1 : 0);
    const formatted = val.toLocaleString("en-IN", { minimumFractionDigits: dp, maximumFractionDigits: dp });
    return unit ? `₹${formatted} ${unit}` : `₹${formatted}`;
};

export const fmtNum = (n, dp = 0) => {
    if (n == null || isNaN(n)) return "—";
    return n.toLocaleString("en-IN", { minimumFractionDigits: dp, maximumFractionDigits: dp });
};

export const fmtPct = (n, dp = 1) => {
    if (n == null || isNaN(n)) return "—";
    return `${n.toFixed(dp)}%`;
};

export const fmtDate = (d) => {
    if (!d) return "—";
    const dt = new Date(d);
    return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "2-digit" });
};

export const posNeg = (n) => (n >= 0 ? "text-pos" : "text-neg");
